exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#app[data-from='clair']>header{display:none}#app[data-from='clair']>.page{margin:0;padding:0}#app[data-from='clair'] .side-menu{display:none}#app[data-from='clair'] ~ .github-corner{display:none}#app[data-from='clair'] .block-demo--fixed .bock-demo__ctrl{padding-right:15px !important}\n", ""]);

